export const RequestedSpacePriceChangeTypeEnum =  {
    MONTHLY: 'MONTHLY',
    DAILY: 'DAILY',
    HOURLY: 'HOURLY',
    SHIFT: 'SHIFT',
};

export const priceRangeLabels = {
    [RequestedSpacePriceChangeTypeEnum.MONTHLY]: 'Por mes',
    [RequestedSpacePriceChangeTypeEnum.DAILY]: 'Por día',
    [RequestedSpacePriceChangeTypeEnum.HOURLY]: 'Por hora',
    [RequestedSpacePriceChangeTypeEnum.SHIFT]: 'Por turno',
};
